import { gameProviderTypes } from '@configs/layout';

const ChartBoxInner = ({ type, title, data }) => {
  return (
    <div className={`chart-ranking-inner ${type}`}>
      <div className="chart-ranking-header">
        <p className="btn-ico-single trophy">
          <span className="blind">트로피 순위</span>
        </p>
        <p className="chart-ranking-header-tit">{title}</p>
      </div>
      <ol className="chart-ranking-data">
        {data?.length > 0 &&
          data.map((item, index) => {
            return (
              <li key={index}>
                {/* TODO:아래는 임의로 처리한것임 */}
                <p
                  className={`btn-ico-single ${item.rank > 0 ? 'rank-up' : item.rank == 0 ? 'no-change' : 'rank-down'}`}
                  data-rank={Math.abs(item.rank).toString()}
                >
                  <span className="blind">순위 상승</span>
                </p>
                <div className="game-img">
                  <img src={item.icon} />
                </div>
                <div className="game-info">
                  <p className="game-tit">{item.title}</p>
                  <p className="game-desc">{item.hasOwnProperty('summary') ? item.summary : item.description}</p>
                </div>
                <button type="button" className="btn-ico-single short">
                  <span className="blind">상승</span>
                </button>
              </li>
            );
          })}
        {data?.length === 0 && <li className="no-data">No Data</li>}
      </ol>
    </div>
  );
};

export default ChartBoxInner;
